module.exports = __webpack_public_path__ + "media/images/area/area_tokyoM400-ce598224b07f13a7bd6f64723ac5d078.jpg";